import styled, { css } from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
import { WarningTriangle } from 'theme/icons';
var AffiliationCta = styled.span.withConfig({
  displayName: "AffiliationBlockCtastyle__AffiliationCta",
  componentId: "sc-1a92t35-0"
})(["", " width:fit-content;border-radius:", ";cursor:pointer;"], function (_ref) {
  var isBroken = _ref.isBroken;
  return isBroken ? css(["position:relative;padding:", " ", " ", " ", ";color:", ";border:1px solid ", ";"], getSpacing(1), getSpacing(3), getSpacing(1), getSpacing(6.5), colorUsage.message.warning, colorUsage.message.warning) : css(["padding:", " ", ";color:", ";border:1px solid ", ";"], getSpacing(1), getSpacing(3), colorUsage.CTAText, colorUsage.CTAText);
}, borderRadius.medium);
var ErrorIcon = styled(WarningTriangle).withConfig({
  displayName: "AffiliationBlockCtastyle__ErrorIcon",
  componentId: "sc-1a92t35-1"
})(["position:absolute;top:", ";left:", ";width:24px;vertical-align:'bottom';& path{fill:", ";}"], getSpacing(1), getSpacing(3), colorUsage.message.warning);
export { AffiliationCta, ErrorIcon };